__turbopack_context__.v({
  "action": "styles-module__J1cZLa__action",
  "button": "styles-module__J1cZLa__button",
  "link": "styles-module__J1cZLa__link",
  "price": "styles-module__J1cZLa__price",
  "table": "styles-module__J1cZLa__table",
  "title": "styles-module__J1cZLa__title",
  "withButtons": "styles-module__J1cZLa__withButtons",
});
